export enum CourseNotificationCategory {
    GENERAL,
    COMMUNICATION,
    IRIS_REVIEW,
}
